<template>
  <article class="article-item article-item--box-column-3-view">
    <div class="article-item__tag">
      <span>{{ type }}</span>
    </div>
    <div class="article-item__header">
      <a v-bind:href="url">
        <img
          class="article-item__header-image"
          :class="{ 'fallback-image': !imageUrlMutable }"
          loading="lazy"
          :src="imageUrlMutable"
          @error="
            () => {
              imageUrlMutable = null
            }
          "
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="article-item__header-play article-item__header-play--show"
          viewBox="0 0 30 30"
          v-if="hasVideo"
        >
          <path
            fill-rule="nonzero"
            d="M15 4.04a10.96 10.96 0 100 21.92 10.96 10.96 0 000-21.92zm5.2 11.72l-8.12 4.04a.37.37 0 01-.53-.33v-8.93a.37.37 0 01.53-.33l8.13 4.1a.81.81 0 010 1.45z"
          />
        </svg>
      </a>
    </div>
    <div class="article-item__body">
      <div class="article-item__core">
        <aside>
          <figure class="article-item__author">
            <div class="article-item__author-image-container">
              <img
                class="article-item__author-image"
                loading="lazy"
                v-bind:src="authorImageUrl"
              />
            </div>
            <figcaption class="article-item__author-info">
              {{ author }} | {{ published }}
            </figcaption>
          </figure>
        </aside>
        <header class="article-item__title">
          <h2 class="article-item__title-text">
            <a v-bind:href="url">{{ title }}</a>
          </h2>
        </header>
        <p class="article-item__summary">
          {{ summary }}
        </p>
      </div>
      <div class="article-item__bottom">
        <a v-bind:href="url" class="article-item__link">
          Læs nu
          <svg
            class="article-item__link-arrow"
            width="8"
            height="9"
            viewBox="0 0 8 9"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.59932 3.93187L3.92608 0.258641C3.70068 0.0332328 3.33522 0.0332328 3.10981 0.258641C2.8844 0.484048 2.8844 0.849507 3.10981 1.07491L5.79771 3.76282H0.599849C0.302397 3.78644 0.0683746 4.0353 0.0683746 4.33883C0.0683746 4.65796 0.327085 4.91667 0.646218 4.91667V4.9172H5.79771L3.10981 7.60511C2.8844 7.83052 2.8844 8.19597 3.10981 8.42138C3.33522 8.64679 3.70068 8.64679 3.92608 8.42138L7.59932 4.74815C7.82473 4.52274 7.82473 4.15728 7.59932 3.93187Z"
            />
          </svg>
        </a>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    type: { default: '', type: String },
    author: { default: '', type: String },
    published: { default: '', type: String },
    title: { default: '', type: String },
    summary: { default: '', type: String },
    url: { default: '', type: String },
    imageUrl: { default: '', type: String },
    authorImageUrl: { default: '', type: String },
    hasVideo: { default: false, type: Boolean },

    boxView: { default: false, type: Boolean },
  },
  data() {
    return {
      imageUrlMutable: this.imageUrl,
    }
  },
}
</script>

<style lang="scss">
@use 'ArticleItem.scss';
</style>
